import * as Yup from 'yup';

const customSchema = ({ type, min, isRequired }) => {
  if (isRequired)
    return Yup.string()
      .min(min, `Please enter a valid  ${type}`)
      .required(`Please enter a valid ${type}`);

  return Yup.string().min(min, `Please enter a valid ${type}`);
};

export default Yup.object().shape({
  houseNo: customSchema({ type: 'address', min: 3, isRequired: true }),
  addressType: Yup.string().required('Please select address type'),

  colony: customSchema({ type: 'address', min: 3, isRequired: true }),
  landmark: customSchema({ type: 'landmark', min: 2, isRequired: true }),
  pincode: Yup.string()
    .when('country', {
      is: 'India',
      then: Yup.string().matches(/^[1-9][0-9]{5}$/, 'Please enter a valid pincode.'),
      otherwise: Yup.string().matches(/^(?!0+$)[0-9A-Za-z]{2,6}$/, 'Please enter a valid pincode.')
    })
    // .matches(/^[0-9]*$/, {
    //   message: 'Please enter a valid pincode.',
    //   excludeEmptyString: false
    // })
    .required('Please enter valid pincode'),
  city: Yup.string().required(''),
});
